import { useEffect, useRef, useCallback } from 'react';

const MAX_ERRORS = 5;
const originalConsoleError = console.error;
let patchInstalled = false;
let captureRefs: React.MutableRefObject<string[]>[] = [];

function installPatch(): void {
  if (patchInstalled) return;
  patchInstalled = true;

  console.error = (...args: unknown[]) => {
    try {
      const errorMessage = args
        .map((arg) => {
          if (typeof arg === 'string') return arg;
          try {
            return JSON.stringify(arg);
          } catch {
            return String(arg);
          }
        })
        .join(' ')
        .slice(0, 500);

      const entry = `[${new Date().toISOString()}] ${errorMessage}`;
      for (const ref of captureRefs) {
        ref.current = [...ref.current.slice(-(MAX_ERRORS - 1)), entry];
      }
    } catch {
      // Never let capture logic break console.error
    }

    originalConsoleError.apply(console, args);
  };
}

function uninstallPatch(): void {
  if (captureRefs.length > 0) return;
  patchInstalled = false;
  console.error = originalConsoleError;
}

export function useConsoleErrorCapture(): { getErrors: () => string[] } {
  const errorsRef = useRef<string[]>([]);

  useEffect(() => {
    captureRefs.push(errorsRef);
    installPatch();

    return () => {
      captureRefs = captureRefs.filter((ref) => ref !== errorsRef);
      uninstallPatch();
    };
  }, []);

  const getErrors = useCallback(() => errorsRef.current, []);

  return { getErrors };
}
